import React from 'react'
import { Button } from 'sdc-react-basics'

export const ReloadButton = ({...params}) => (
  <Button icon="refresh" style={{color: '#090'}} {...params} />
)
